import Section from "../../../../../../models/Section";
import {CostCenter} from "../../../../../../models/CostCenter";
import {CostCenterDrawing} from "../../../../../../models/CostCenterDrawing";

type ImgData = {
    height: number,
    width: number
}

export type DrawingFileInfo = {
    file: File
    url: string
    height: number
    width: number
    section: Section
    costCenter: CostCenter
    drawing: CostCenterDrawing
}

export async function getSelectedDrawingFileInfo(
    file: File,
    section: Section,
    costCenter: CostCenter,
    drawing: CostCenterDrawing
): Promise<DrawingFileInfo> {
    return new Promise<DrawingFileInfo>(async (resolve) => {
        const {url, height, width} = await getDrawingFileData(file)
        return resolve({
            file: file,
            url,
            height,
            width,
            section,
            costCenter,
            drawing
        })
    })
}

export async function getDrawingFileData(drawingFile: File) {
    const imgBlobUrl = URL.createObjectURL(drawingFile)
    const imgData = await new Promise<ImgData>((resolve, reject) => {
        const img = document.createElement('img')
        img.src = imgBlobUrl
        img.onload = function() {
            resolve({
                height: img.height,
                width: img.width
            })
        }
        img.onerror = function() {
            reject()
        }
    })
    return {
        url: imgBlobUrl,
        ...imgData
    }
}